import Vue from 'vue'
import Vuex from 'vuex'
import calendar from './store/calendar'
import user from './store/user'
import time from './store/time'
import task from './store/task'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    calendar,
    time,
    user,
    task
  }
})
